export class Connect {
	static readonly type = '[google search] connect';
}
